// src/pages/Warehouses/EditProductForm.jsx
// تعديل الصنف = نفس شاشة الإضافة (المسار يمرّر :id فتفتح في وضع التعديل)
import AddProductForm from "./AddProduct";

export default AddProductForm;